import Login from 'components/views/login';
import { useQueryParams } from 'hooks/use-query-params';
import { FC } from 'react';
import { Navigate } from 'react-router';
import routes from 'routes';

export const LoginCallback: FC = () => {
  const queryParams = useQueryParams();
  let description: string | null = null;
  if (
    queryParams.has('error_description') &&
    (description = queryParams.get('error_description'))
  ) {
    return <Login error={decodeURI(description)} originalUrl="/" />;
  }
  //https://admin.local.aktify.io:3000/login/callback?error_description=Error+in+SAML+request+to+Identity+Provider%3A+No+SAML+assertion+found+in+the+SAML+response.+&state=gldC68dIXFH1aiEMQXC4gd19AXbjxz3W-7b226f726967696e616c55726c223a222f227d&error=server_error
  return <Navigate to={routes.home.path} />;
};
